import axios from "axios";
import {environmentConfig} from "@/config/enviromentConfig";

export default class TelkomService {
    static async updateUsername(msisdn, username, productId) {
        return await axios.post(`${environmentConfig.telkomService}/update-username`, {
            msisdn: msisdn,
            username: username,
            productId: productId
        })
    }
    static async updateUserState(msisdn, productId) {
        return await axios.post(`${environmentConfig.telkomService}/update-user-state`, {
            msisdn: msisdn,
            productId: productId
        })
    }

    static async subscribe(msisdn, serviceId, externalRef, channel, doiChannel) {
        return await axios.post(`${environmentConfig.telkomService}/subscribe`, {
            msisdn: msisdn,
            svc_id: serviceId,
            ext_ref: externalRef,
            channel: channel,
            doi_channel: doiChannel
        })
    }

    static async unSubscribe(msisdn, productId) {
        return await axios.post(`${environmentConfig.telkomService}/unsubscribe`, {
            msisdn,
            productId
        })
    }

    static async getUser(msisdn, productId) {
        return await axios.post(`${environmentConfig.telkomService}/v2-get-user-via-product-id`, {
            msisdn: msisdn,
            productId: productId
        })
    }
}
